import type { FunctionComponent } from 'react';
import { useCallback, useState } from 'react';

import type { IPaymentProcessResponse } from '@endeavour/payment-integration';
import { RedirectMethod } from '@endeavour/payment-integration';

import { Button, ButtonSize, Rounding } from '../../../shared/components/button/button';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Loader } from '../../../shared/components/loader/loader';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';

import styles from './redirect.module.scss';

const style = createStyleHelper(styles, 'redirect');

export interface IRedirectProps {
    className?: string;
    responseModel: IPaymentProcessResponse;
}

export const Redirect: FunctionComponent<IRedirectProps> = ({ className, responseModel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const output = responseModel.redirectOutput;

    const submit = useCallback(() => {
        if (output?.html) {
            document.write(output.html);
        }

        setIsLoading(true);
    }, [output?.html]);

    if (output?.method === RedirectMethod.GET && output.url) {
        window.location.href = output.url;
        return <Loader />;
    }

    return (
        <div className={createClassName([className, style()])}>
            {isLoading ? (
                <Loader />
            ) : (
                <Button
                    className={style('button')}
                    size={ButtonSize.SMALL}
                    rounding={Rounding.SMALL}
                    onClick={() => submit()}
                >
                    <FormattedMessage
                        id={'cashier.popup.click-to-proceed'}
                        defaultMessage={'Click to proceed redirect'}
                    />
                </Button>
            )}
        </div>
    );
};
